import {Component, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {UserErrors} from '../models';
import {MiniBookAdminService} from '../service/mini-book-admin.service';
import {GeneralConfig} from '../shared/GeneralConfig';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-general-config',
    templateUrl: './general-config.component.html',
    styleUrls: ['./general-config.component.css'],
    standalone: false
})
export class GeneralConfigComponent implements OnInit {

  generalConfig?: GeneralConfig;
  generalConfigErrors?: UserErrors;

  constructor(
    private adminService: MiniBookAdminService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.refreshGeneralConfig();
  }

  refreshGeneralConfig() {
    this.adminService.generalConfig.getGeneralConfig().subscribe({
      next: generalConfig => {
        this.generalConfig = generalConfig
      },
      error: err => {
        if ('error' in err && typeof err.error == 'object' && 'type' in err.error && err.error.type === 'UserErrors') {
          this.generalConfigErrors = err.error;
        } else {
          const message: any = {
            type: 'PlainErrorMessage',
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message
          };
          this.generalConfigErrors = {
            type: 'UserErrors',
            messages: [message]
          };
        }
      }
    });
  }

  saveGeneralConfig() {
    if (this.generalConfig) {
      this.adminService.generalConfig.updateGeneralConfig(this.generalConfig)
        .subscribe({
          next: updatedData => {
            this.generalConfig = updatedData;
            this.messageService.add({severity: 'success', summary: 'Gesichert', detail: 'Einstellungen wurden gespeichert'});
          },
          error: err => {
            if ('error' in err && typeof err.error == 'object' && 'type' in err.error && err.error.type === 'UserErrors') {
              this.generalConfigErrors = err.error;
            } else {
              const message: any = {
                type: 'PlainErrorMessage',
                summary: 'Fehler bei der Kommunikation mit dem Backend',
                detail: err.message
              };
              this.generalConfigErrors = {
                type: 'UserErrors',
                messages: [message]
              };
            }
          }
        });
    }
  }

}
